import { ErrorBoundary } from '@components/error-boundary';
import { useAppSelector } from '@/hooks/redux/redux';
import CommonModuleContainer from '@/containers/pages/filials/edit/components/common/modules';
import { ModulesEnum } from '@/types/enums/filials';

const ProjectsModule = () => {
  const { filial } = useAppSelector((state) => state.filials);

  return (
    <ErrorBoundary componentTitle="Projects module page">
      <CommonModuleContainer filial={filial} currentModule={ModulesEnum.Projects} />
    </ErrorBoundary>
  );
};

export default ProjectsModule;
